import ApiService from "../../../ApiService";

const DetailsService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/apiexceptionrule/details/loadscreenview", { id }, successCallback, failureCallback);
    },

    add: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/apiexceptionrule/details/add", vo, successCallback, failureCallback);
    },
};

export default DetailsService;